module.exports = __webpack_public_path__ + "static/media/public-institutes-tag-icon.81d69d3f.svg";